import { z } from "zod";

export const PipelineByIdSchema = z.object({
  pipelineId: z.coerce.number()
});

export const CreatePipelineSchema = z.object({
  name: z.string().min(1, "Name is required")
});

export const UpdatePipelineSchema = z.object({
  name: z.string().min(1, "Name is required")
});

export type CreatePipelineInput = z.infer<typeof CreatePipelineSchema>;
export type UpdatePipelineInput = z.infer<typeof UpdatePipelineSchema>;

export const SinglePipelineSchema = z.object({
  id: z.number(),
  name: z.string()
});

export const PipelineSchema = z.object({
  id: z.number(),
  name: z.string(),
  canBeDeleted: z.boolean()
});

export type TPipeline = z.infer<typeof PipelineSchema>;

export const PipelinesSchema = z.array(PipelineSchema);
